export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_CONFIG = 'USER_CONFIG'
export const REQUEST_PERMISSIONS = 'REQUEST_PERMISSIONS'
export const USER_GROUP = 'USER_GROUP'
